import { Component, Input, Output, EventEmitter,
  ChangeDetectorRef,
  OnChanges, SimpleChanges,
} from '@angular/core';
import * as _ from 'lodash';
import { DomSanitizer } from '@angular/platform-browser';
import { PermissionsService } from 'shared/permissions/permissions.service';

import { getColWidth } from '../search-helpers';
import { SortModel } from '../sort.model';
import { isRetina } from 'utils/media';


@Component({
  moduleId: module.id,
  selector: 'sorting-panel',
  templateUrl: 'sorting-panel.component.html',
  styleUrls: ['sorting-panel.component.scss'],
})
export class SortingPanelComponent implements OnChanges {
  readonly isHighDpi = isRetina();

  @Input() collapsed: boolean = false;
  @Input() columns: Array<any> = [];
  @Input() currentSortModel: SortModel;
  @Input() selectAll: string;
  @Input() selectedAllChecked: boolean = false;
  @Input() isPagination: boolean = true;
  @Input() showSelectAll: boolean = true;
  @Input() isVersion2: boolean = false;
  @Input() colCssProcess: boolean = false; // New way of handling col width (with colCssWidth field)
  @Input() disableSelect: boolean = false;

  @Output() changeSort = new EventEmitter();
  @Output() selectAllClick = new EventEmitter();
  @Output() selectAllChange = new EventEmitter();

  selectItems: Array<any> = [
    {
      action: 'on-page',
      title: 'Select all on page',
      active: true,
    },
    {
      action: 'in-list',
      title: 'Select all results',
      active: false,
    },
    {
      action: 'deselect-all',
      title: 'Deselect All',
      active: false,
    }
  ];

  constructor(
    protected sanitizer: DomSanitizer,
    protected ref: ChangeDetectorRef,
    protected permissionsService: PermissionsService,
  ) {
  }

  ngOnChanges(changes: SimpleChanges) {
    // if columns or order were changed
    if (changes.columns || changes.disableSelect || changes.showSelectAll || changes.collapsed) {
      this.ref.detectChanges();
    }

    // if sortModel was changed
    if (changes.currentSortModel && changes.currentSortModel.currentValue &&
      (!changes.currentSortModel.previousValue ||
      (_.get(changes.currentSortModel, 'previousValue.column') !== _.get(changes.currentSortModel, 'currentValue.column')) ||
      (_.get(changes.currentSortModel, 'previousValue.sort') !== _.get(changes.currentSortModel, 'currentValue.sort'))
    )) {
      this.ref.detectChanges();
    }
  }

  /*******************************************
   * COMPONENT PUBLIC METHODS
   *******************************************/

  public getGhostSortAttr(item: any): string {
    if (item.title === 'select-all-btn' || !item.sortable) { return null; }
    return this.isColumnActive(item) ? 'asc' : 'desc';
  }

  public isColumnActive(item: any): boolean {
    if (!this.currentSortModel) { return false; }
    const col = item.sortName ? item.sortName : item.col;
    return this.currentSortModel.sort === 'asc' && col === this.currentSortModel.column;
  }

  public hasPermissions(column: any) {
    if (!column.showPermissions) { return true; }
    return this.permissionsService.hasPermission(column.showPermissions);
  }

/*******************************************
 * COMPONENT HANDLERS
 *******************************************/

  onSortingClick(item: any) {
    if (!item.sortable) { return; }
    const sortModel = new SortModel();
    sortModel.column = item.sortName ? item.sortName : item.col;
    sortModel.sort = this.isColumnActive(item) ? 'desc' : 'asc';
    this.changeSort.emit(sortModel);
  }

  onSelectAllClick(event: MouseEvent, select: string) {
    event.preventDefault();
    if (this.disableSelect) { return; }
    this.selectAllClick.emit(select);
  }

  onSelectAllChange(event: any) {
    event.preventDefault();
    if (this.disableSelect) { return; }
    this.selectAllChange.emit(event.target.checked);
  }

  /*******************************************
   * COMPONENT PRIVATE METHODS
   *******************************************/

  private getColCssWidth(col: any) {
    if (this.columns) {
      return this.sanitizer.bypassSecurityTrustStyle(getColWidth(col, this.columns));
    } else {
      return '';
    }
  }

}
